import {
  checkCryptoState,
  type FabricHttpCheckCryptoStateApi,
  type FabricHttpSetCryptoStateApi,
  setCryptoState,
} from './crypto-state.js';
import { downloadFile, type FabricHttpDownloadApi } from './download.js';
import { type FabricHttpRequestApi, request } from './request.js';
import { type FabricHttpUploadFileApi, uploadFile } from './upload.js';

export type FabricHttpApi = {
  /**
   * 发送网络请求, 返回业务数据报文协议
   */
  request: FabricHttpRequestApi;
  /**
   * 下载网络文件到本地
   */
  downloadFile: FabricHttpDownloadApi;
  /**
   * 上传本地文件到网络服务器
   */
  uploadFile: FabricHttpUploadFileApi;

  /**
   * 置网络通道是否走全报文加密.
   */
  setCryptoState: FabricHttpSetCryptoStateApi;

  /**
   * 获取网络通道是否走全报文加密的标识位.
   */
  checkCryptoState: FabricHttpCheckCryptoStateApi;
};

export const fabricHttp: FabricHttpApi = {
  request,
  downloadFile,
  uploadFile,
  setCryptoState,
  checkCryptoState,
};
